module.exports = __webpack_public_path__ + "static/media/119-television.8f7e0ac6.svg";